<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <app-division-form
    [companyId]="companyId()"
    [initialValue]="initialValue()"
    [label]="fieldLabel()"
    [saving]="saving()"
    (submitted)="onSubmit($event)" />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
